import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import useLogsContaBancaria from "core/features/contas_bancarias/hooks/useLogsContaBancaria";

import { CloseModalButton } from "components/Button/CloseModalButton";
import TimelineLogs from "components/TimelineLogs";
import { useCurrentTenant } from "core/features/auth/tenant.store";

interface ModalHistoricoContaBancariaProps {
  tenantContaId?: string;
  isOpenModal: boolean;
  onClose: () => any;
}

export default function ModalHistoricoContaBancaria({
  tenantContaId,
  isOpenModal,
  onClose,
}: ModalHistoricoContaBancariaProps) {
  const { tenant } = useCurrentTenant();
  const { data, isFetching } = useLogsContaBancaria(tenant.id, tenantContaId);

  useLoading(isFetching);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="500px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <CloseModalButton
              showBorder={false}
              close={onClose}
              closeModalLabel="Fechar"
            />
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex>
          <Heading mb={4} size="md">
            Histórico
          </Heading>
        </Flex>
        <Flex py="4px" flexDir={"column"}>
          {data?.map((item, key) => (
            <TimelineLogs key={key} data={item} />
          ))}
        </Flex>
      </Modal>
    </>
  );
}
